type AnalyticsValue = string | number | boolean;

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    loadGTM?: () => void;
  }
}

export function hasAnalyticsConsent(): boolean {
  try {
    return localStorage.getItem('flashweb_cookie_consent') === 'granted';
  } catch {
    return false;
  }
}

/**
 * Tracking functions work with Consent Mode v2:
 * - Before consent: events are sent as cookieless pings (no cookies set).
 * - After consent: gtag('consent', 'update', ...) is called by CookieBanner, enabling full cookies.
 */
export function trackPageView(path = window.location.pathname + window.location.search): void {
  // GTM is only injected once consent exists. Consent Mode v2 pings sent before
  // consent are cookieless anyway, and this bootstrap mount is what used to pull
  // the 175 KB tag-manager bundle on the very first (Lighthouse) load.
  if (hasAnalyticsConsent()) {
    if (typeof window.loadGTM === 'function') {
      window.loadGTM();
    }
  }
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title
    });
  }
}

export function trackEvent(name: string, params: Record<string, AnalyticsValue> = {}): void {
  if (hasAnalyticsConsent()) {
    if (typeof window.loadGTM === 'function') {
      window.loadGTM();
    }
  }
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}
